module.exports = __webpack_public_path__ + "img/services.47aa672e.png";